export default {
  methods: {
    /**
     * 需求欄位
     * communityList;
     * cityList;
     * openComIdArr;
     * removeComIdArr;
     * $auth
     * */
    async setCommunityList () {
      if (!this.$auth.loggedIn) return
      if (this.communityList.length > 0) return

      const communityList = await this.$store.dispatch('getPersonalCommunity')
      for (const community of communityList) {
        community.isDisabled = false
        community.showName = `${community.Community} ${community.TabletNote}`
        let city = community.City
        if (city.substring(0, 1) === '台') {
          city = '臺' + city.substring(1)
        }
        community.City = city
        const theCity = _.find(this.cityList, { MainName: city })
        if (!theCity) {
          community.isDisabled = true
        } else {
          const theArea = _.find(theCity.AreaList, { ParentName: community.Area })
          if (!theArea) {
            community.isDisabled = true
          }
        }

        // 開放社區、排除社區設定
        if (this.openComIdArr.includes(community.ComId)) community.isDisabled = false
        if (this.removeComIdArr.includes(community.ComId)) community.isDisabled = true

        let address = community.Address
        if (address.substring(0, 1) === '台') {
          address = '臺' + address.substring(1)
        }
        if (address.substring(0, city.length) === city) {
          address = address.replace(city, '')
        }
        if (address.substring(0, community.Area.length) === community.Area) {
          address = address.replace(community.Area, '')
        }
        community.showAddress = `${address} (${community.TabletNote})`
        this.communityList.push(community)
      }
    },
    /**
     * 需求欄位
     * communityList;
     * isCommunity;
     * $auth
     * */
    getNotInServeReason () {
      let result = ''
      if (!this.$auth.loggedIn) { // 未登入
        result = 'notLoggedIn'
      } else if (this.isCommunity && this.communityList.length === 0) { // 已登入，未有開通社區
        result = 'noCommunity'
      } else if (this.isCommunity) { // 已登入，開通社區未在服務範圍
        const canServiceCommunity = this.communityList.filter(community => !community.isDisabled)
        result = canServiceCommunity.length === 0 ? 'noServiceCommunity' : ''
      }

      return result
    }
  }
}
